import clsx from "clsx";
import type { ReactNode, HTMLAttributes } from "react";
import { forwardRef } from "react";

import styles from "./scrollable.module.css";

type Props = HTMLAttributes<HTMLDivElement> & {
    children: ReactNode;
};

const Scrollable = forwardRef<HTMLDivElement, Props>((props, ref) => {
    const { children, className, ...otherProps } = props;

    return (
        <div {...otherProps} ref={ref} className={clsx(styles.scrollable, className)}>
            {children}
        </div>
    );
});

Scrollable.displayName = "Scrollable";

export { Scrollable };
export type { Props as ScrollableProps };
